var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"color":"black","dense":"","dark":""}},[_c('v-toolbar-title',[_c('span',{staticClass:" PB"},[_vm._v(" KL06")])]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""}},[_c('AccountMenu')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }